import {useGetABTestQuery} from 'core/services/ABTestService';

export const useGetAbTest = (params: {abTestName: string}) => {
    const {abTestName} = params;
    const {data, isSuccess} = useGetABTestQuery({abTestName});

    return {data, isSuccess};
};
